import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Input, FormGroup, Label, Modal } from 'reactstrap';
import ReactDevicePreview from 'react-device-preview';
import { useHistory } from 'react-router-dom';
import parse from 'html-react-parser';
import clsx from 'clsx';

// Import the new Quill Editor
import CustomQuillEditor from '../../components/CustomQuillEditor/CustomQuillEditor';

import MobileScreen from './MobileScreen';
import Loader from '../../shared/loader/loader';
import { getQuestion, saveQuestion } from './Api/questions';
import PopupAddEditQuestions from './PopupAddEditQuestions';
import { GetQueryParam, ShowNotification } from '../../helpers/general/generalHelpers';
import { Buffer } from 'buffer';

const AddEditMcqQuestion = (props) => {

  Buffer.from('anything', 'base64');
  window.Buffer = window.Buffer || require('buffer').Buffer;

  // Refs for each Quill editor instance
  const questionQuillRef = useRef(null);
  const sampleAnswerQuillRef = useRef(null);
  const markingQuillRef = useRef(null);
  const optionQuillRef = useRef(null);

  const [question, setQuestion] = useState({
    loaded: false, type: '', subject: {}, chapter: {}, difficulty: '', body: ''
  });
  // State for editor content is now simple HTML strings
  const [sampleAnswer, setSampleAnswer] = useState('');
  const [marking, setMarking] = useState('');
  const [options, setOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMarkingOpen, setModalMarkingOpen] = useState(false);
  const [questionModalOpen, setQuestionModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  // State for the option being edited in the modal
  const [editingOptionHtml, setEditingOptionHtml] = useState('');
  const [modalAnswerOpen, setModalAnswerOpen] = useState(false);
  const [, update] = useState(0);
  const forceUpdate = () => {
    update((n) => !n);
  };
  const [ansIndex, setAnsIndex] = useState(0);
  const optionsNames = ['A', 'B', 'C', 'D', 'E'];

  const history = useHistory();

  useEffect(() => {
    if (props?.location?.state) {
      setQuestion({ loaded: true, ...props?.location?.state });
      setLoader(false);
    } else if (props?.location?.search) {
      const questionId = GetQueryParam(props?.location?.search, 'id');
      setLoader(true);
      getQuestion(questionId)
          .then((response) => {
            const questionData = response.data.question;
            let body = questionData.questions.body || '';

            setQuestion({
              loaded: true,
              ...questionData,
              type: questionData.type,
              subject: questionData.subject,
              chapter: questionData.chapter,
              difficulty: questionData.difficultyLevel,
              body: body
            });

            setMarking(questionData.questions?.markingAttachment || '');
            let explanation = questionData.Feedback?.body.split('Explanation: ');
            setSampleAnswer(explanation && explanation.length > 1 ? explanation[1] : '');

            let fetchedOptions = questionData.mcqOptions ? Object.keys(questionData.mcqOptions).map((k) => {
              return questionData.mcqOptions[k];
            }) : [];
            setOptions(fetchedOptions);
          })
          .catch((error) => {
            const message = error && error.response && error.response.data ? error.response.data.message : 'There was an error fetching question information, please try again!';
            ShowNotification({ type: 'error', message });
            console.error(error);
            throw error;
          })
          .finally(() => {
            setLoader(false);
          });
    } else {
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location]); // Simplified dependencies

  useEffect(() => {
    forceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question]);


  const addOption = (event) => {
    if (options.length < 5) {
      setOptions([
        ...options,
        {
          body: '',
          marks: 1,
          answer: false
        }
      ]);
    } else {
      ShowNotification({ type: 'warning', message: 'Maximum 5 options are allowed.' });
    }
  };

  const removeOption = (event) => {
    if (options.length > 0) {
      let newOptions = options.slice(0, options.length - 1);
      setOptions(newOptions);
    } else {
      ShowNotification({ type: 'warning', message: 'Add options first.' });
    }
  };

  function toggleModal() {
    setModalOpen(!modalOpen);
  }

  function toggleMarkingModal() {
    setModalMarkingOpen(!modalMarkingOpen);
  }

  function toggleEditQuestionModal() {
    setQuestionModalOpen(!questionModalOpen);
  }
  function toggleAnswerModal() {
    setModalAnswerOpen(!modalAnswerOpen);
  }

  const handleSaveQuestion = async () => {
    setLoader(true);

    let mcqOptionsBackend = {};
    let optionsNamesSmall = optionsNames.map((opt) => opt.toLowerCase());
    options.forEach((opt, idx) => {
      mcqOptionsBackend[optionsNamesSmall[idx]] = opt;
    });

    let newQuestion = {
      _id: question._id,
      type: question.type,
      studyLevelId: question.subject.studyLevelId || question.studyLevelId,
      subject: question.subject.id || question.subject._id,
      subjectName: question.subject.label || question.subject.title,
      sampleAnswerAvailable: sampleAnswer !== '',
      difficultyLevel: question.difficulty,
      mcqOptions: mcqOptionsBackend,
      paperNumber: question.paperNumber || '',
      session: question.session || '',
      year: question.year,
      versionNumber: question.versionNumber || '',
      questionNumber: question.questionNumber || '',
      questions: {
        body: question.body,
        sampleAnswer: sampleAnswer,
        markingAttachment: marking
      },
      Feedback: {
        "body": `<b>Explanation: </b> ${sampleAnswer}`
      },
    };

    saveQuestion(newQuestion, props.history, setLoader);
  };

  const SampleAnswerModal = (
      <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          size="lg"
      >
        <Card>
          <CardBody>
            <Loader loading={loader} />
            <Row>
              <Col md="12">
                <h5>Explanation</h5>
              </Col>
              <Col md="12">
                <CustomQuillEditor
                    ref={sampleAnswerQuillRef}
                    initialHtml={sampleAnswer}
                    onTextChange={() => {
                      if (sampleAnswerQuillRef.current) {
                        setSampleAnswer(sampleAnswerQuillRef.current.root.innerHTML);
                      }
                    }}
                />
              </Col>
              <Col md="12" className="mt-4">
                <Row className="justify-content-center">
                  <Button
                      type="button"
                      onClick={toggleModal}
                      className="agora-button cancel-button border-radius"
                  >
                    Close
                  </Button>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Modal>
  );

  const MarkingModal = (
      <Modal
          isOpen={modalMarkingOpen}
          toggle={toggleMarkingModal}
          size="lg"
      >
        <Card>
          <CardBody>
            <Loader loading={loader} />
            <Row>
              <Col md="12">
                <h5>Add Marking</h5>
              </Col>
              <Col md="12">
                <CustomQuillEditor
                    ref={markingQuillRef}
                    initialHtml={marking}
                    onTextChange={() => {
                      if (markingQuillRef.current) {
                        setMarking(markingQuillRef.current.root.innerHTML);
                      }
                    }}
                />
              </Col>
              <Col md="12" className="mt-4">
                <Row className="justify-content-center">
                  <Button
                      type="button"
                      onClick={toggleMarkingModal}
                      className="agora-button cancel-button border-radius"
                  >
                    Close
                  </Button>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Modal>
  );
  const CorrectAnswerModal = (
      <Modal
          isOpen={modalAnswerOpen}
          toggle={toggleAnswerModal}
          size="lg"
      >
        <Card>
          <CardBody>
            <Loader loading={loader} />
            <Row>
              <Col md="12">
                <h5>Update Correct Answer</h5>
              </Col>
              <Col md="12">
                <CustomQuillEditor
                    ref={optionQuillRef}
                    initialHtml={editingOptionHtml}
                    onTextChange={() => {
                      if (optionQuillRef.current) {
                        setEditingOptionHtml(optionQuillRef.current.root.innerHTML);
                      }
                    }}
                />
              </Col>
              <Col md="12" className="mt-4">
                <Row className="justify-content-center">
                  <Button
                      type="button"
                      onClick={toggleAnswerModal}
                      className="agora-button cancel-button border-radius"
                  >
                    Cancel
                  </Button>
                  <Button
                      type="submit"
                      className="agora-button save-button border-radius"
                      onClick={ () => {
                        let newOptions = [...options];
                        newOptions[ansIndex].body = editingOptionHtml;
                        setOptions(newOptions);
                        toggleAnswerModal();
                      }}
                  >
                    Save
                  </Button>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Modal>
  );
  return (
      <React.Fragment>
        <Loader loading={loader} />

        <div className="page-content">
          <Container fluid className="relative">
            <Row>
              <Col xs="12">
                <div
                    onClick={() => {
                      window.history.back();
                    }}
                    className="page-title-box d-flex align-items-center justify-content-between"
                >
                <span className="mb-0 font-size-14 back-button">
                  <i className="fa fa-arrow-left"></i> Back to Questions
                </span>
                </div>
              </Col>
            </Row>

            <Card>
              <CardBody>
                <Row className="subject-info-section">
                  <Col md="3" className="justify-content-center">
                    <h4 className="card-title mb-3">{question.chapter?.label || question.chapter?.title}</h4>
                  </Col>
                  <Col className="justify-content-left">
                  <span
                      className={
                          'badge badge-pill badge-soft-success font-size-12 px-3 mr-1 ' +
                          (question.type.toLowerCase() === 'mcq' ? 'text-uppercase' : 'text-capitalize')
                      }
                  >
                    {question.type}
                  </span>
                    <span
                        className={clsx({
                          'badge badge-pill font-size-12 text-capitalize px-3': true,
                          'badge-soft-success': question.difficulty === 'Easy',
                          'badge-soft-info': question.difficulty === 'Medium',
                          'badge-soft-warning': question.difficulty === 'Hard'
                        })}
                    >
                    {question.difficulty}
                  </span>
                  </Col>
                  <Col className="col text-md-right text-sm-right">
                    <i onClick={toggleEditQuestionModal} className="bx bxs-edit-alt font-size-16 btn p-0"></i>
                  </Col>
                </Row>
                <Row>
                  <Col md="2" className="subject-creator-info-section font-size-13">
                    <div className="subject-creator-info">
                      <p>Study level: {question?.studyLevelId || '-'}</p>
                      <p>Year: {question.year || '-'}</p>
                    </div>
                  </Col>
                  <Col md="2" className="subject-creator-info-section font-size-13">
                    <div className="subject-creator-info">
                      <p>Subject: {question.subject?.title || '-'}</p>
                      <p>Session: {question.session || '-'}</p>
                    </div>
                  </Col>
                  <Col md="2" className="subject-creator-info-section font-size-13">
                    <div className="subject-creator-info">
                      <p>Paper Number: {question.paperNumber || '-'}</p>
                      <p>Version Number: {question.versionNumber || '-'}</p>
                    </div>
                  </Col>
                  <Col className="subject-creator-info-section font-size-13">
                    <div className="subject-creator-info">
                      <p>Marking Scheme ID: {question.markingSchemeId || '-'}</p>
                      <p>Question ID: {question.internalId || '-'}</p>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row>
                  <Col md="12" className="justify-content-center">
                    <h4 className="card-title mb-3">Question Detail</h4>
                  </Col>
                </Row>
                <Row className="section-top">
                  <Col md="6" className="text-center section-right">
                    <ReactDevicePreview device="iphone8" scale="0.7">
                      <div className="device-content">
                        <MobileScreen
                            mcq
                            cardHeaderText={question.subject?.label || question.subject?.title || '-'}
                            cardSubHeaderText={question.chapter?.label || question.chapter?.title || '-'}
                            setOptions={setOptions}
                            options={options}
                            forceUpdate={forceUpdate}
                        >
                          {parse(question.body || '')}
                        </MobileScreen>
                      </div>
                    </ReactDevicePreview>
                  </Col>
                  <Col md="6">
                    <h5 className="my-2 text-black-50">Question</h5>
                    {question.loaded && (
                        <CustomQuillEditor
                            ref={questionQuillRef}
                            initialHtml={question.body}
                            onTextChange={() => {
                              if (questionQuillRef.current) {
                                const currentHtml = questionQuillRef.current.root.innerHTML;
                                if (question.body !== currentHtml) {
                                  setQuestion(prev => ({ ...prev, body: currentHtml }));
                                }
                              }
                            }}
                        />
                    )}
                    {options.map((option, idx) => {
                      return (
                          <div
                              key={'option_' + idx}
                              style={{ flexDirection: 'row', display: 'flex', marginTop: 30, width: '100%' }}
                          >
                            <h5 className="my-2 text-black-50">Option {optionsNames[idx]}</h5>
                            <span className="custom-control custom-checkbox mt-1 ml-3">
                          <FormGroup check>
                            <Label check>
                              <Input
                                  type="checkbox"
                                  checked={!!option.answer}
                                  onChange={() => {
                                    let newOptions = JSON.parse(JSON.stringify(options));
                                    newOptions[idx].answer = !newOptions[idx].answer;
                                    setOptions(newOptions);
                                  }}
                              />{' '}
                              Correct Answer
                            </Label>
                          </FormGroup>
                        </span>
                            <Button type="button" color="link" className="btn btn-link waves-effect ml-auto" onClick={()=>{
                              setAnsIndex(idx);
                              setEditingOptionHtml(option.body || '');
                              toggleAnswerModal();
                            }}>
                              <i className="bx font-size-20 bx-edit-alt"></i>
                              <span style={{ verticalAlign: 'top' }} className="font-size-15">
                              {' '}
                                Update{' '}
                            </span>
                            </Button>

                          </div>
                      );
                    })}
                    <br />
                    <Button type="button" color="link" className="btn btn-link waves-effect mr-4" onClick={addOption}>
                      <i className="bx font-size-20 bxs-plus-square"></i>
                      <span style={{ verticalAlign: 'top' }} className="font-size-15">
                      {' '}
                        Add Option{' '}
                    </span>
                    </Button>
                    <Button type="button" color="link" className="btn btn-link waves-effect mr-4" onClick={toggleModal}>
                      <i
                          className={`bx font-size-20 ${
                              sampleAnswer ? 'bx-check-circle' : 'bxs-conversation'
                          }`}
                      ></i>
                      <span style={{ verticalAlign: 'top' }} className="font-size-15">
                      {' '}
                        Explanation{' '}
                    </span>
                    </Button>
                    <Button
                        type="button"
                        color="link"
                        className="btn btn-link waves-effect mr-4"
                        onClick={toggleMarkingModal}
                    >
                      <i className={`bx font-size-20 ${marking ? 'bx-badge-check' : 'bxs-badge-check'}`}></i>
                      <span style={{ verticalAlign: 'top' }} className="font-size-15">
                      {' '}
                        Marking{' '}
                    </span>
                    </Button>
                    {options.length > 0 && (
                        <Button
                            type="button"
                            color="link"
                            className="btn btn-link waves-effect mr-4"
                            onClick={removeOption}
                        >
                          <i className="bx font-size-24 bxs-trash text-danger"></i>
                        </Button>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md="12" className="text-right">
                    <Button
                        type="button"
                        onClick={() => {
                          history.goBack();
                        }}
                        className="agora-button cancel-button border-radius"
                    >
                      Cancel
                    </Button>
                    <Button className="agora-button save-button border-radius" onClick={handleSaveQuestion}>
                      Save
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </div>
        {SampleAnswerModal}
        {MarkingModal}
        {CorrectAnswerModal}
        <PopupAddEditQuestions
            edit
            show={questionModalOpen}
            toggleModal={toggleEditQuestionModal}
            question={question}
            setQuestion={setQuestion}
        />
      </React.Fragment>
  );
};

export default AddEditMcqQuestion;